<template>
  <div class="w-full flex flex-col items-center h-screen">
    <div class="m-auto">
      <div class="text-center">
        <EmptyResultsSVG />
      </div>
      <div class="pt-8 text-center main--content pb-32">
        <p class="text-zt-primary-200 text-xl leading-tight font-normal">
          {{ $t('message.searchComponent.emptyResults.message') }}
        </p>
        <p class="pt-2 text-zt-dark-300 text-lg font-normal">
          {{ $t('message.searchComponent.emptyResults.legend') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import EmptyResultsSVG from './SVG/EmptyResults.vue'
export default {
  name: 'SearchEmptyResults',
  components: {
    EmptyResultsSVG,
  },
}
</script>

<style scoped>
.main--content {
  max-width: 450px;
}
</style>
